"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import BreadcrumbList from "./BreadcrumbList";

const Breadcrumb = ({ data }) => {
  const [breadcrumb, setBreadcrumb] = useState([]);

  const pathnameStr = usePathname();

  useEffect(() => {
    let pathArr = [];
    if (pathnameStr.startsWith("/")) {
      pathArr = pathnameStr.substring(1).split("/");
      if (pathArr.length >= 2) {
        // Remove first 2 element an array like: [docs, {category}]
        pathArr.splice(0, 2);
      }
    }

    const defaultBreadcrumb = [
      {
        name: "",
        slug: "/",
        icon: "home",
      },
      {
        name: "Docs",
        slug: "/docs",
      },
      {
        name: data.name,
        slug: `/docs/${data.slug}`,
      },
    ];

    // Generate Breadcrumb array
    if (pathArr?.length) {
      let childCategoryDoc = {};

      const breadcrumbArr = pathArr.reduce((acc, curr, index) => {
        if (pathArr.length === 1) {
          // Parent Docs

          if (data?.parentDocs?.length) {
            const parentDoc = data?.parentDocs?.find((doc) => doc.slug === curr);

            if (parentDoc) {
              acc.push({
                name: parentDoc?.sub_title || parentDoc.title,
                slug: `/docs/${data.slug}/${parentDoc?.slug}`,
              });
            }
          }

          if (data?.childDocs?.length) {
            const childCategoryDoc = data?.childDocs.find((doc) => doc.child_cat_slug === curr);
            if (childCategoryDoc) {
              acc.push({
                name: childCategoryDoc?.child_cat_name,
                slug: `/docs/${data.slug}/${childCategoryDoc?.child_cat_slug}`,
              });
            }
          }
        } else if (pathArr.length === 2) {
          // Child Docs
          if (index === 0) {
            const childCategoryDocData = data?.childDocs.find((doc) => doc.child_cat_slug === curr);

            if (childCategoryDocData) {
              childCategoryDoc = childCategoryDocData;

              acc.push({
                name: childCategoryDocData?.child_cat_name,
                slug: `/docs/${data.slug}/${childCategoryDocData?.child_cat_slug}`,
              });
            }
          }

          if (childCategoryDoc?.child_cat_posts?.length && index === 1) {
            const doc = childCategoryDoc?.child_cat_posts.find((post) => post.slug === curr);

            if (doc) {
              acc.push({
                name: doc?.sub_title || doc?.title,
                slug: `/docs/${data.slug}/${childCategoryDoc?.child_cat_slug}/${doc?.slug}`,
              });
            }
          }
        }

        return acc;
      }, []);

      setBreadcrumb([...defaultBreadcrumb, ...breadcrumbArr]);
    } else {
      setBreadcrumb(defaultBreadcrumb);
    }
  }, [pathnameStr]);

  return (
    <ul className="jlt-flex jlt-gap-1 jlt-items-center jlt-mt-16">
      {breadcrumb?.length
        ? breadcrumb.map((bread, i) => (
            <BreadcrumbList
              key={i}
              name={bread.name}
              slug={bread.slug}
              position={i + 1}
              icon={bread?.icon}
              last={i === breadcrumb?.length - 1}
            />
          ))
        : null}
    </ul>
  );
};

export default Breadcrumb;
